import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SecretsOfAnubis_1Screen } from "../SecretsOfAnubis/game_1Screen";

export class SecretsOfAnubisLink_1Screen extends SecretsOfAnubis_1Screen {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData ) {
        super(multigameParams, initData, "SecretsOfAnubisLink");
    }
    
}

  


